// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"detail-technology-content_wrapper__gzMkD","section":"detail-technology-content_section__q41lu"};